import request from '../../../../shared/lib/request';
import { RPC } from '../../../../shared/constants';

const getDashboardData = (method, params) =>
  request({
    url: RPC.DASHBOARD_NETWORK,
    method: 'POST',
    data: {
      method,
      params,
    },
  });

const DashboardNetwork = {
  getDashboardData,
};

export default DashboardNetwork;



// WEBPACK FOOTER //
// ./app/shared/services/rpc/dashboard-network/index.js